export const NAV_OPEN_EVENT = 'onboarding-open-nav';
export const NAV_EXPAND_GROUP_EVENT = 'onboarding-expand-nav-group';

/** data-onboarding attr → NavBar group id */
export const NAV_GROUP_BY_ATTR = {
  'nav-students': 'training',
  'nav-attendance': 'training',
  'nav-applications': 'training',
  'nav-staff': 'school',
  'nav-settings': 'school',
  'nav-venues': 'school',
  'nav-inventory': 'school',
  'nav-finance': 'finance',
};

export function getAttrFromTarget(target) {
  if (typeof target !== 'string') return null;
  const m = target.match(/data-onboarding="([^"]+)"/);
  return m?.[1] ?? null;
}

export function openNavForTour() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(NAV_OPEN_EVENT));
  }
}

export function expandNavGroup(groupId) {
  if (typeof window !== 'undefined' && groupId) {
    window.dispatchEvent(new CustomEvent(NAV_EXPAND_GROUP_EVENT, { detail: { groupId } }));
  }
}

export function prepareNavStepBefore(target) {
  const attr = getAttrFromTarget(target);
  const groupId = attr ? NAV_GROUP_BY_ATTR[attr] : null;
  openNavForTour();
  if (groupId) expandNavGroup(groupId);
  const delay = groupId ? 420 : 320;
  return new Promise((r) => setTimeout(r, delay));
}
